import React from 'react'
import clsx from 'clsx'
import styles from '../category-selector.module.scss'
import Icon from '../../../Icon'
import PropTypes from 'prop-types'

const WithGroup = ({
  group,
  selectedGroups,
  selectedOptions,
  openedGroups,
  handleCheckboxChange,
  handleGroupCheckboxChange,
  EmptyRowTemplate,
  toggleOptGroup,
  OptGroupTemplate,
  RowTemplate,
  onSelect,
}) => (
  <div
    className={clsx(styles['optgroup'], {
      [styles['optgroup--opened']]: openedGroups.includes(group.label),
    })}
  >
    <div className={styles['optgroup-controls']}>
      <div className={styles['option']}>
        <OptGroupTemplate
          {...group}
          checked={selectedGroups.includes(group.label)}
          onChange={() => handleGroupCheckboxChange(group.label)}
        />
      </div>
      <Icon
        name={'arrow1-down'}
        size={'m'}
        className={styles['optgroup-toggler']}
        onClick={() => toggleOptGroup(group.label)}
      />
    </div>
    {openedGroups.includes(group.label) && (
      <div className={styles['option-group']}>
        {group.options.map(({ label, id, ...rest }) =>
          id ? (
            <div className={styles['option']} key={'group-' + id}>
              <RowTemplate
                id={id}
                label={label}
                {...rest}
                checked={selectedOptions.includes(id)}
                onChange={() => handleCheckboxChange(id)}
              />
            </div>
          ) : (
            <div
              onClick={() => onSelect(selectedOptions)}
              className={clsx(styles['option'], styles['option_empty'])}
              key={'group-' + label}
            >
              <EmptyRowTemplate label={label} {...rest} />
            </div>
          ),
        )}
      </div>
    )}
  </div>
)

WithGroup.propTypes = {
  group: PropTypes.shape({
    label: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
    ),
  }).isRequired,
  selectedGroups: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedOptions: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ).isRequired,
  openedGroups: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleCheckboxChange: PropTypes.func.isRequired,
  handleGroupCheckboxChange: PropTypes.func.isRequired,
  EmptyRowTemplate: PropTypes.func.isRequired,
  toggleOptGroup: PropTypes.func.isRequired,
  OptGroupTemplate: PropTypes.func.isRequired,
  RowTemplate: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
}

export default WithGroup
